import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=89f0ed24&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
import style0 from "./Documents.vue?vue&type=style&index=0&id=89f0ed24&prod&scoped=true&lang=css"
import style1 from "./Documents.vue?vue&type=style&index=1&id=89f0ed24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f0ed24",
  null
  
)

export default component.exports